
{/**
   error codes 
   401: user session out  or if permission denied 

   403: if user try  to  request invalid query staring 

   400: if user  passing  invalid arguments in api call 

   405 : no idea

   404 : no idea
*/}

const WORKKARD_DETAIL_MASTER_DATA_ERROR  = {
    400 : 'Failed to fetch workkard data. please try after sometime.',
    405 : 'Failed to fetch workkard data. please try after sometime.'
};

const ACTIVITY_LISTING_ERROR  = {
    400 : 'Failed to fetch Activity data. please try after sometime.',
    405 : 'Failed to fetch activity data. please try after sometime.'
};

const  FETCH_ASSOCIATED_WARKKARD_DATA_ERROR = {
    400 : 'Failed to fetch Activity data. please try after sometime.',
    405 : 'Failed to fetch activity data. please try after sometime.'
};

const FETCH_ASSOCIATED_WARKKARD_FILTER_ERROR = {
    400 : 'Failed to fetch Activity data. please try after sometime.',
    405 : 'Failed to fetch activity data. please try after sometime.'
};

const  ACTIVITY_DETAIL_DATA_ERROR = {
    400 : 'Failed to fetch Activity data. please try after sometime.',
    405 : 'Failed to fetch activity data. please try after sometime.'
};

const  FETCH_MIDDLE_PANEL_NOTES_ERROR  = {
    400 : 'Failed to fetch Activity data. please try after sometime.',
    405 : 'Failed to fetch activity data. please try after sometime.'
};

const FETCH_MIDDLE_PANEL_FILE_ERROR  = {
    400 : 'Failed to fetch Activity data. please try after sometime.',
    405 : 'Failed to fetch activity data. please try after sometime.'
};

const FETCH_MIDDLE_PANEL_DIARIES_ERROR   = {
    400 : 'Failed to fetch Activity data. please try after sometime.',
    405 : 'Failed to fetch activity data. please try after sometime.'
};

const FETCH_MIDDLE_PANEL_LOG_ERROR = {
    400 : 'Failed to fetch Activity data. please try after sometime.',
    405 : 'Failed to fetch activity data. please try after sometime.'
};

const FETCH_MIDDLE_PANEL_PARTIES_ERROR  = {
    400 : 'Failed to fetch Activity data. please try after sometime.',
    405 : 'Failed to fetch activity data. please try after sometime.'
};

const ADD_ASSOCIATE_PARTY_ERROR  = {
    400 : 'This party is already associated',
};





export {
    WORKKARD_DETAIL_MASTER_DATA_ERROR,
    ACTIVITY_LISTING_ERROR,
    FETCH_ASSOCIATED_WARKKARD_DATA_ERROR,
    FETCH_ASSOCIATED_WARKKARD_FILTER_ERROR,
    ACTIVITY_DETAIL_DATA_ERROR,
    FETCH_MIDDLE_PANEL_NOTES_ERROR,
    FETCH_MIDDLE_PANEL_FILE_ERROR,
    FETCH_MIDDLE_PANEL_DIARIES_ERROR,
    FETCH_MIDDLE_PANEL_LOG_ERROR,
    FETCH_MIDDLE_PANEL_PARTIES_ERROR,
    ADD_ASSOCIATE_PARTY_ERROR
}